var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view'),_c('Logs')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hni-vertical"}},[_c('h1',[_vm._v("Het Nieuwe Instituut")])])}]

export { render, staticRenderFns }